import { render, staticRenderFns } from "./FuelsMainSection.vue?vue&type=template&id=7b610e78"
import script from "./FuelsMainSection.vue?vue&type=script&lang=js"
export * from "./FuelsMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports